import {getEnv} from '../../common/env/env';
import {getCommonBadge} from '../../common/getCommonBadge';
import {getRankingMetaList} from '../../common/getRankingMetaList';
import {ItemSeriesDto} from '../../common/shared/api/gateway/ItemSeriesDto.interface';
import {getDiscountRateText} from '../../common/shared/utils/getDiscountRateText';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {removeCategoryName} from '../../common/shared/utils/removeCategoryName';
import {ItemType, Maybe, RankingListViewItem, User} from '../generated/types';
import {createAgeGrade} from './AgeGrade';

export function createRankingListViewItem(
  userInfo: Maybe<User>,
  param: {itemSeriesDto: ItemSeriesDto}
): RankingListViewItem {
  if ('itemSeriesDto' in param) {
    return withItemSeriesDto(userInfo, param.itemSeriesDto);
  } else {
    throw new Error('알 수 없는 타입입니다');
  }
}

function withItemSeriesDto(
  userInfo: Maybe<User>,
  itemSeriesDto: ItemSeriesDto
): RankingListViewItem {
  const {
    series_id,
    category_uid,
    title,
    thumbnail,
    badge,
    service_property,
    operator_property,
    category,
    sub_category,
    authors,
    is_waitfree,
    waitfree_period_by_minute,
    age_grade,
    business_model,
  } = itemSeriesDto;
  const {badgeList, ageGradeBadge, statusBadge} = getCommonBadge({
    itemType: ItemType.RankingListView,
    badge,
    age_grade,
    is_waitfree,
    waitfree_period_by_minute: waitfree_period_by_minute || null,
    self_censorship: operator_property?.self_censorship,
    business_model,
  });
  return {
    id: `RankingListViewItem-${series_id}`,
    type: ItemType.RankingListView,
    ageGrade: createAgeGrade(age_grade),
    selfCensorship: operator_property?.self_censorship,
    title,
    badgeList,
    ageGradeBadge,
    statusBadge,
    thumbnail: thumbnail.startsWith('http')
      ? thumbnail
      : getKageUrl({
          kageUrlPrefix: getEnv().kageUrlPrefix,
          kageId: thumbnail,
          resolution: 'th3',
        }),
    metaList: getRankingMetaList({
      viewCount: service_property?.view_count,
      subcategory: removeCategoryName(sub_category, category_uid),
      authors,
    }),
    scheme: `kakaopage://open/content?series_id=${series_id}`,
    rank: service_property?.rank || '',
    eventLog: {
      eventMeta: {
        id: `kakaopage://open/content?series_id=${series_id}`,
        type: 'seriesId',
        name: title,
        category,
        subcategory: sub_category,
        provider: '서비스',
        series: title,
        series_id: String(series_id),
      },
      customProps: {
        landing_path: 'contents',
        view_type: 'series_list_view',
      },
    },
    discountRate: operator_property?.cash_info?.discount_rate,
    discountRateText: getDiscountRateText({
      discountRate: operator_property?.cash_info?.discount_rate,
      setDiscountRate: operator_property?.cash_info?.set_discount_rate,
    }),
  };
}
